import { cloneElement, isValidElement } from "react"
import Iconify from "minimals-template/components/Iconify"

const BASE_STROKE_WEIGHT = 1.5

export const NAV_OVERRIDES = {
    "/app": { icon: "mynaui:home", group: "Overview", priority: 10, iconWeight: 2 },
    "/app/actions": { icon: "mynaui:lightning", group: "Overview", priority: 20 },
    "/app/shared-with-me": { icon: "streamline:cloud-share", group: "Overview", priority: 30 },
    "/app/schedules?id=schedules": { icon: "hugeicons:files-01", priority: 10, iconWeight: 2 },
    "/app/ai": { icon: "mingcute:search-ai-line", priority: 20 },
    "/app/schedules?id=myList": { icon: "hugeicons:file-edit", iconWeight: 2 },
    "/app/schedules?id=basket-ScheduleBasket": { icon: "hugeicons:favourite", iconWeight: 2 },
    "/app/schedules?id=basket-Tag": { icon: "solar:tag-outline", iconWeight: 2 },
    "/app/schedules?id=search": { icon: "mingcute:search-line" },
    "/app/assets": { icon: "majesticons:checkbox-list-line" },
    "/app/optimiser": { icon: "codicon:graph", hFlip: true, iconWeight: 1.9 },
    "/app/sharing": { icon: "tabler:share", group: "Management" },
    "/app/admin": { icon: "hugeicons:shield-user", group: "Management", iconWeight: 2 },
    "/app/recycler": { icon: "gravity-ui:trash-bin", group: "Management" },
    "/app/system-admin": { icon: "lucide:shield-cog-corner", group: "Management" },
    "/app/sfg20admin": { icon: "lucide:shield-user", group: "Management" },
}

const OVERRIDE_ICONS = buildOverrideIcons()
export function applyNavOverrides(items) {
    return items.map(applyOverride)
}

function applyOverride(item) {
    const override = NAV_OVERRIDES[item.path]
    if (!override) return item

    const subPaths = { ...item.subPaths }
    if (override.group !== undefined) subPaths.group = override.group
    if (override.priority !== undefined) subPaths.priority = override.priority

    return { ...item, subPaths, icon: OVERRIDE_ICONS[item.path] ?? weightedIcon(item.icon, override) }
}

function buildOverrideIcons() {
    const icons = {}
    for (const [path, { icon, iconWeight, hFlip }] of Object.entries(NAV_OVERRIDES)) {
        if (icon) icons[path] = <Iconify icon={icon} hFlip={hFlip} sx={iconWeightSx(iconWeight)} />
    }
    return icons
}

function weightedIcon(icon, { iconWeight }) {
    const sx = iconWeightSx(iconWeight)
    if (!sx || !isValidElement(icon)) return icon
    return cloneElement(icon, { sx: { ...sx, ...icon.props.sx } })
}

function iconWeightSx(weight) {
    if (!weight) return undefined
    return {
        "& [stroke]": { strokeWidth: weight },
        "& [fill]:not([fill='none'])": {
            stroke: "currentColor",
            strokeWidth: Math.max(weight - BASE_STROKE_WEIGHT, 0),
        },
    }
}
